'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var User = (function () {
	function User(acl) {
		var roles = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

		_classCallCheck(this, User);

		this.acl = acl;
		this.addRole(roles);
	}

	User.prototype.makeArray = function makeArray(item) {
		if (!item) {
			return [];
		}
		return _lodash2['default'].isArray(item) ? item : [item];
	};

	User.prototype.addRole = function addRole(roles) {
		roles = this.makeArray(roles);
		this.roles = _lodash2['default'].union(this.roles, roles);
	};

	User.prototype.setRole = function setRole(roles) {
		this.roles = this.makeArray(roles);
	};

	User.prototype.isAllowed = function isAllowed(resources, permission) {
		return this.acl.isAllowed(this.roles, resources, permission);
	};

	return User;
})();

exports['default'] = User;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-acl/src/User.js
 ** module id = 982
 ** module chunks = 1
 **/